import useShowOpciones from "../../../../hooks/useShowOpciones";
import Opcion from "../OpcionesActaDetalle2/Opcion";

const OpcionesActaDetalle3 = ({ type = null }) => {
    const opciones = useShowOpciones();

    useShowOpciones()
    return (
        <>
            <div className="d-flex gap-3">
                {
                    opciones?.map((opcion, index) => {
                        if (type == "acta_detalle" && opcion.label == "Constancia") {
                            return null
                        } else {
                            return (
                                <div key={index}>
                                    <Opcion
                                        icono={opcion.icono}
                                        label={opcion.label}
                                        modal={opcion.modal}
                                    />
                                </div>
                            )
                        }
                    }
                    )
                }
            </div>
        </>
    );
}
export default OpcionesActaDetalle3;